import { colorToAlpha } from "@bridgesplit/utils";
import { PaletteOptions } from "@mui/material";

import { BRAND_COLORS } from "./theme";

export function getLightPalette(): PaletteOptions {
    return {
        primary: {
            main: BRAND_COLORS.BLACK
        },
        secondary: {
            main: BRAND_COLORS.BLUE
        },
        background: {
            default: BRAND_COLORS.LIGHT,
            paper: BRAND_COLORS.LIGHT
        },
        success: {
            main: "#0FB872"
        },
        error: {
            main: "#DF5C5F"
        },
        warning: {
            main: BRAND_COLORS.ORANGE
        },
        info: {
            main: "#113EDD"
        },
        divider: colorToAlpha(BRAND_COLORS.BLACK, 0.08),
        text: {
            primary: BRAND_COLORS.BLACK,
            secondary: BRAND_COLORS.GRAY,
            disabled: colorToAlpha(BRAND_COLORS.BLACK, 0.4)
        }
    };
}
